import type { JSX } from "solid-js"

export type FilePreviewProps = {
  path: string
  contents: string
  cacheKey?: string
  viewportHeight?: number
  onRendered?: () => void
}

export type FilePreviewHandler = {
  extensions: string[]
  hasSourceToggle?: boolean
  render: (props: FilePreviewProps) => JSX.Element
}

const registry: FilePreviewHandler[] = []

export function registerFilePreviewHandler(handler: FilePreviewHandler) {
  registry.push(handler)
}

export function getFilePreviewHandler(path: string | undefined): FilePreviewHandler | undefined {
  if (!path) return
  const dot = path.lastIndexOf(".")
  if (dot === -1) return
  const ext = path.slice(dot + 1).toLowerCase()
  return registry.find((h) => h.extensions.includes(ext))
}
